import { CalendarClock, CalendarCheck } from "lucide-react";

const STYLES = {
  overdue: { bg: "bg-red-50", text: "text-red-600", label: "Review overdue", Icon: CalendarClock },
  due_soon: { bg: "bg-amber-50", text: "text-amber-700", label: "Review due soon", Icon: CalendarClock },
};

export function ReviewBadge({ review, testId }) {
  if (!review) return null;
  const s = STYLES[review.flag];
  if (!s) return null;
  const { Icon } = s;
  const when = review.review_date
    ? new Date(review.review_date).toLocaleDateString("en-IE", { day: "numeric", month: "short" })
    : "";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold font-['Outfit'] ${s.bg} ${s.text}`}
      title={`Support plan review ${review.flag === "overdue" ? "was due" : "due"} ${when}`}
    >
      <Icon size={12} /> {s.label}{when ? ` · ${when}` : ""}
    </span>
  );
}
